import { Box } from '@osmosis/tailwind-ui/components/Box';
import Image from 'next/image';
import React from 'react';

type Props = {
  src: string;
};

/**
 * `EventsBannerBackground` is a functional component that displays an image as a background.
 * @param {Object} props - The properties that define the component.
 * @param {string} props.src - The source URL of the image to display.
 * @returns {React.JSX.Element} The `EventsBannerBackground` component.
 */
const EventsBannerBackground = (props: Props) => {
  const { src } = props;
  return (
    <Box cn="absolute top-0 z-[0] h-full w-full">
      <Image
        src={src}
        alt=""
        fill={true}
        className="object-cover"
        priority={true}
      />
    </Box>
  );
};

export default EventsBannerBackground;
